<app-nav-header></app-nav-header>
<div style="max-width: 64rem; margin: 0 auto">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
